import React from "react";
import Banner from "../../main/Courses/Banner/Banner";
import LiveCourseContainer from "../../main/Courses/LiveCourses/LiveCourseContainer";
import ContactFormMain from "../../main/home/Contactform/ContactFormMain";
import { useSearchParams } from "react-router-dom";

const Courses = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  
    // To read a specific query parameter
    const id = searchParams.get("course_id");
  return (
    <div>
      <Banner />
      <LiveCourseContainer id={id} />
      <ContactFormMain />
    </div>
  );
};

export default Courses;
